import { JSX, useState } from "react";
import "./inforCetnerTool.css";
import { useNavigate } from 'react-router-dom';
import PortalButton from "./portalButton";

interface ButtonProps {
    button: string;
}

function ButtonElement({button}: ButtonProps)
{
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState<boolean>(false);

    function OpenCalendar()
    {

    }


    function TaxOrganizer()
    {
        window.open('/files/ca_tax_organizer.pdf', '_blank');
    }

    function References()
    {
        navigate('/reference-chart');
    }

    function TaxForms()
    {

    }




    if (button === "calendar")
    {
        return(
            <button
                className={`icon-button ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={OpenCalendar}
            >
                <div className="icon-button-icon">
                    <i className={`fa-solid fa-calendar-days ${isHovered ? "fa-bounce" : "" }`}></i>
                </div>
                <div className="icon-button-text">Events Calendar</div>
            </button>
        )
    }
    else if (button === "organizer")
    {
        return(
            <button
                className={`icon-button ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={TaxOrganizer}
            >
                <div className="icon-button-icon">
                    <i className={`fa-solid fa-table-columns ${isHovered ? "fa-bounce" : "" }`}></i>
                </div>
                <div className="icon-button-text">Client Tax Organizer</div>
            </button>
        )
    }
    else if (button === "reference")
    {
        return(
            <button
                className={`icon-button ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={References}
            >
                <div className="icon-button-icon">
                    <i className={`fa-solid fa-chart-bar ${isHovered ? "fa-bounce" : "" }`}></i>
                </div>
                <div className="icon-button-text">Quick Reference Charts</div>
            </button>
        )
    }
    else if (button === "taxForms")
    {
        return(
            <button
                className={`icon-button ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={TaxForms}
            >
                <div className="icon-button-icon">
                    <i className={`fa-solid fa-book ${isHovered ? "fa-bounce" : "" }`}></i>
                </div>
                <div className="icon-button-text">CRA Tax Forms and Publications Library</div>
            </button>
        )
    }
    else if (button === "portal")
    {
        return(
            <PortalButton/>
        )
    }


    return(<></>)
}



// Define the props type
interface SectionProps {
    button: string;
    title: string;
    text: string | (string | JSX.Element)[];
    reverse?: boolean; // optional
}




export default function ButtonSection({ button, title, text, reverse = false }: SectionProps) {
    if (button === "portal")
    {
        return (
            <div className={`info ${reverse ? "reverse" : ""}`}>
                <div className="info-content" style={{textAlign: 'left'}}>
                    <h3 style={{color: 'black', textAlign: 'left'}}>{title}</h3>
                    <ul>
                        {Array.isArray(text)
                        ? text.map((item, index) => <li key={index}>{item}</li>)
                        : <li>{text}</li>
                        }
                    </ul>
                </div>
                <ButtonElement button={button}/>
            </div>
        );
    }
    return (
        <div className={`info ${reverse ? "reverse" : ""}`}>
            <ButtonElement button={button}/>
            <div className="info-content">
                <h2>{title}</h2>

                {Array.isArray(text)
                ? text.map((item, index) => <p key={index}>{item}</p>)
                : <p>{text}</p>
                }
            </div>
        </div>
    );
}
